export const joinItems: { title: string, content: string[], link?: string, linkAriaLabel?: string }[] = [
  { title: 'join.step-1.title', content: ['join.step-1.content-1', 'join.step-1.content-2', 'join.step-1.content-3'] },
  {
    title: 'join.step-2.title',
    content: ['join.step-2.content-1', 'join.step-2.content-2'],
    link: 'join.declaration.link',
    linkAriaLabel: 'join.step-2.link',
  },
  { title: 'join.step-3.title', content: ['join.step-3'], link: 'join.link', linkAriaLabel: 'join.step-3.link' },
];

export const joinItemsUa: { title: string, content: string[], link?: string, linkAriaLabel?: string }[] = [
  { title: 'join.step-1.title', content: ['join.step-1.content-1'] },
  {
    title: 'join.step-2.title',
    content: ['join.step-2.content-1'],
  },
  { title: 'join.step-3.title', content: ['join.step-3'], link: 'join.link', linkAriaLabel: 'join.step-3.link' },
];
